import { makeStyles, Theme } from '@material-ui/core/styles';
import React, { FunctionComponent, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Header } from '../../components/Header/Header';
import { LegalFooter } from '../../components/LegalFooter/LegalFooter';
import { Notification } from '../../components/Notification/Notification';
import { QuickMenu } from '../../components/QuickMenu/QuickMenu';
import { useUniversalTracking } from '../../lib/tracking/universalTracking';
import ProductSection from './components/ProductSection';

export interface Props extends RouteComponentProps, StateProps, DispatchProps {}

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
	},
}));

const Home: FunctionComponent<Props> = (props) => {
	const { fetchNotification } = props;

	const classes = useStyles();

	useEffect(() => {
		fetchNotification();
	}, [fetchNotification]);

	const { trackPageView } = useUniversalTracking();

	useEffect(
		() => {
			trackPageView(props.location.pathname);
		},
		// eslint-disable-next-line
		[props.location.pathname]
	);

	return (
		<div className={`${classes.root}`} data-cy={'homePage'}>
			<Header />
			<Notification
				message={`${props.notificationCode} ${props.notificationMessage}`}
				onClose={props.markAsRead}
			/>
			{/* the section to choose the actual product */}
			<ProductSection />
			{/* small menu in the top right corner */}
			<QuickMenu />
			<LegalFooter />
		</div>
	);
};

interface StateProps {
	salesType: string[];
	notificationCode: string;
	notificationMessage: string;
}

interface DispatchProps {
	fetchNotification(): void;
	fetchContent(): void;
	markAsRead(): void;
}

export default Home;
